import axios from 'axios'

export async function get(params, url) {
    const bodyFormData = getFormData(params)
    const token = getCookie('_wid')
    const res = await axios.get(process.env.VUE_APP_API_URL + url,
        {
            params,
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    )
    return res
}

export async function get_1(params, url) {
    const token = getCookie('_wid')
    const res = await axios.get(url,
        {
            params,
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    )
    return res
}

export async function get_3(params, url) {
    const username = params.username
    const target = process.env.VUE_APP_API_URL + url + '/' + username
    const token = getCookie('_wid')
    const res = await axios.get(target,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    )
    return res
}

export async function post(params, url) {
    let data
    if(params instanceof FormData){
        data = params
    }else{
        data = getFormData(params)
    }
    const token = getCookie('_wid')
    const res = await axios.post(process.env.VUE_APP_API_URL + url,  data , {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    });
    return res
}

export async function post_1(params, url) {
    let data
    if(params instanceof FormData){
        data = params
    }else{
        data = getFormData(params)
    }
    const token = getCookie('_wid')
    const res = await axios.post(url, data);
    return res
}

// export function authHeader() {
//     const token = getCookie('_wid')
//     return {
//         Authorization: `Bearer ${token}`,
//     };
// }
function getCookie(key){
    const cookies = document.cookie
                        .split(';')
                        .map(cookie => cookie.split('='))
                        .reduce((accumulator, [key, value]) =>
                        ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{})
    return cookies[key]
}
function getFormData(params){
    var bodyFormData = new FormData();
    Object.keys(params).forEach((key) => {
        bodyFormData.append(key, params[key])
    })
    return bodyFormData
}